import {TelephoneLink} from '../TelephoneLink/TelephoneLink';
import {RichTextResponsiveTable} from './RichText.ResponsiveTable';

TelephoneLink('.rich-text a[href^="tel:"]');
RichTextResponsiveTable('.rich-text figure.table');
